module.exports = __webpack_public_path__ + "static/map-usa-d83d3e3b3001939616acaf2b5f3e8693.png";